module.exports = __webpack_public_path__ + "static/media/linechart.768e0b3a.svg";